/**
 * Shopping Preferences Constants
 *
 * Re-exports from the new lib/shopping-preferences module for backward compatibility.
 * This file maintains the old import paths while using the new architecture.
 */

export const FORCE_SHOPPING_PREFS_MODAL_PATHNAME = '/me/shopping-preferences/';

// Re-export from new types module
export { WOMEN_UNIVERSE, MEN_UNIVERSE } from '@lib/shopping-preferences/types';

// Re-export storage keys
export { LOCAL_KEY, SESSION_KEY } from '@helpers/shopping-preferences/storage';
